import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
// import { resolve } from "path";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: 'active',
    base: process.env.BASE_URL,
    routes: [
        // {
        // 	path: "/",
        // 	meta: {},
        // 	name: "Root"
        // 	// redirect: {
        // 	// 	name: "entrance"
        // 	// }
        // },

        {
            path: '/',
            name: 'entrance',
            component: () =>
                import(
                    /* webpackChunkName: "entrance" */ `@/views/Entrance.vue`
                ),
        },

        {
            path: '/balance',
            component: () =>
                import(
                    /* webpackChunkName: "balance" */ `@/views/Balance/Balance.vue`
                ),

            children: [
                {
                    path: '',
                    component: () =>
                        import(
                            /* webpackChunkName: "balanceInfo" */ `@/views/Balance/BalanceInfo.vue`
                        ),
                },

                {
                    path: 'recharge',
                    name: 'recharge',
                    component: () =>
                        import(
                            /* webpackChunkName: "recharge" */ `@/views/Balance/BalanceRecharge.vue`
                        ),
                },
            ],
        },

        {
            path: '/tariff',
            name: 'tariff',
            component: () =>
                import(/* webpackChunkName: "tariff" */ `@/views/Tariff.vue`),
        },

        {
            path: '/history',
            name: 'history',
            component: () =>
                import(/* webpackChunkName: "history" */ `@/views/History.vue`),
        },

        {
            path: '/devices',
            component: () =>
                import(
                    /* webpackChunkName: "devices" */ `@/views/Devices/Devices.vue`
                ),

            children: [
                {
                    path: '',
                    component: () =>
                        import(
                            /* webpackChunkName: "devicesList" */ `@/views/Devices/DevicesList.vue`
                        ),
                },

                {
                    path: 'new',
                    name: 'new',
                    component: () =>
                        import(
                            /* webpackChunkName: "new" */ `@/views/Devices/DevicesNew.vue`
                        ),
                },

                {
                    path: 'confirm',
                    name: 'confirm',
                    component: () =>
                        import(
                            /* webpackChunkName: "confirm" */ `@/views/Devices/DevicesConfirm.vue`
                        ),
                },
            ],
        },

        {
            path: '/settings',
            name: 'settings',
            component: () =>
                import(
                    /* webpackChunkName: "settings" */ `@/views/Settings.vue`
                ),
        },

        {
            path: '/dispatcher',
            name: 'dispatcher',
            component: () =>
                import(
                    /* webpackChunkName: "dispatcher" */ `@/views/Dispatcher.vue`
                ),
        },
        {
            path: '/404',
            name: '404',
            component: () =>
                import(
                    /* webpackChunkName: "notFound" */ `@/views/NotFound.vue`
                ),
        },

        {
            path: '*',
            redirect: '/404',
        },
    ],
});

// do sth before page will loaded
router.beforeEach((to, from, next) => {
    if (to.path == '/404') {
        store.state.showNavbar = false;
    }
    if (to.path !== '/') {
        let user = JSON.parse(localStorage.getItem('user'));
        if (user) {
            if (to.path == '/dispatcher') {
                store.state.showNavbar = false;
            }
            next();
            // store.state.preloader = true;
        } else {
            next('/');
        }
    } else {
        store.state.showNavbar = false;
        next();
    }
});

export default router;
